module.exports = __webpack_public_path__ + "img/pr-1.160b4f6a.png";